export default {
  title: 'HubRise',
  setup: {
    description: 'Del data med andre applikationer.',
  },
  form: {
    is_menus_sync_enabled: 'Synkroniser menu',
    is_inventory_sync_enabled: 'Synkroniser lager',
    is_opening_hours_sync_enabled: 'Synkroniser åbningstider',
    is_order_acceptance_mode_sync_enabled: 'Synkroniser status optaget / sat på pause',
    variant_ref: 'Menuvariant',
    variant_ref_default: 'Standard',
  },
  tabs: {
    settings: 'Indstillinger',
    service_types: 'Servicetyper',
    payments: 'Betalinger',
    charges: 'Gebyrer',
    deals: 'Tilbud',
    discounts: 'Rabatter',
    customers: 'Kunder',
  },
  customers: {
    description:
      'Slet en enkelt kundes data hos HubRise, f.eks. efter en anmodning om sletning af data. Dette kan ikke fortrydes.',
    customer: 'Kunde',
    placeholder: 'Søg efter navn, e-mail eller telefon…',
  },
  mapping: {
    description:
      'Knyt hver {{provider}}-enhed til den tilsvarende HubRise-værdi og det tilsvarende navn. Lad en række stå tom for at bruge {{provider}}-standarderne.',
    entity: '{{provider}}',
    value: 'HubRise-værdi',
    name: 'HubRise-navn',
  },
  connecting: {
    title: 'Fuldfører HubRise-forbindelsen…',
    description: 'Det tager et par sekunder. Hold denne side åben.',
    error_title: 'HubRise-forbindelsen tager længere tid end forventet',
    error_description:
      'HubRise er godkendt, men forbindelsen er endnu ikke bekræftet. Tjek igen om lidt – hvis det bliver ved med at fejle, så start forbindelsen forfra.',
  },
  buttons: {
    connect: 'Opret forbindelse til HubRise',
    check_again: 'Tjek igen',
    disconnect: 'Afbryd forbindelsen',
    go_to_hubrise: 'Gå til HubRise',
    pull_menus: 'Hent menu',
    pull_inventory: 'Hent lager',
    save: 'Gem',
    delete_customer: 'Slet kunde',
  },
  toasts: {
    connected: 'HubRise er tilsluttet',
    connect_cancelled: 'HubRise-forbindelsen blev annulleret',
    connect_error: 'HubRise-forbindelsen kunne ikke startes',
    connect_timeout: 'HubRise-forbindelsen kunne endnu ikke bekræftes',
    local_changes_replaced:
      'HubRise-indstillingerne blev opdateret et andet sted – dine ikke-gemte ændringer er blevet erstattet',
    disconnect_success: 'HubRise er blevet frakoblet',
    disconnect_error: 'Kunne ikke frakoble HubRise',
    pull_menus_success: 'Menusynkronisering er startet',
    pull_menus_error: 'Kunne ikke hente menuen',
    pull_inventory_success: 'Lagersynkronisering er startet',
    pull_inventory_error: 'Kunne ikke hente lageret',
    save_success: 'HubRise-indstillingerne er gemt',
    save_error: 'Kunne ikke gemme HubRise-indstillingerne',
    load_customers_error: 'Kunne ikke indlæse kunderne',
    delete_customer_success: 'Sletning af kundedataene er anmodet',
    delete_customer_error: 'Kunne ikke slette kundedataene',
  },
  delete_customer_confirm: {
    title: 'Slet denne kunde fra HubRise?',
    description: 'Kundens data slettes hos HubRise. Dette kan ikke fortrydes.',
    ok: 'Slet',
    cancel: 'Annuller',
  },
  disconnect_confirm: {
    title: 'Frakobl HubRise?',
    description: 'Dette stopper synkroniseringen af menuer, lager og ordrer med HubRise.',
    ok: 'Afbryd forbindelsen',
    cancel: 'Annuller',
  },
  connected: {
    title: 'Forbundet til HubRise',
    description: 'Din HubRise-konto er nu forbundet.',
    account: 'Konto',
    location: 'Lokation',
    catalog: 'Katalog',
    customer_list: 'Kundeliste',
  },
};
